import { API_ENDPOINTS } from '../../constants/apiEndpoints';
import { ENVIRONMENT_CONFIG } from '../../constants/environmentConfig';
import fetcher from '../../helpers/fetcher';
import { unwrapDataResponse } from '../../utils/unwrapDataResponse';

export const getPriceConfigList = async (filterParams: any) => {
  try {
    const response = await fetcher.get(
      API_ENDPOINTS.PRICE_CONFIG.GET_PRICE_CONFIG_LIST,
      filterParams,
      {},
      ENVIRONMENT_CONFIG.CONSUMER_PRICE_SERVICE
    );
    return {
      ...response,
      data: unwrapDataResponse<any>(response.data),
    };
  } catch (error: any) {
    throw error;
  }
};

